import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLine, FadeIn, SectionLabel } from "@/components/Reveal";
import { SERVICES } from "@/lib/data";

export default function Services() {
  return (
    <main data-testid="services-page" className="bg-white">
      <section className="pt-40 pb-20 grain relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <FadeIn>
            <SectionLabel>Services</SectionLabel>
          </FadeIn>
          <h1 className="mt-6 font-syne font-extrabold tracking-tighter leading-[0.95] text-[13vw] sm:text-7xl lg:text-8xl text-bm-ink">
            <MaskedLine delay={0.1}>OUR</MaskedLine>
            <MaskedLine delay={0.24}>
              <span className="text-bm-blue">EXPERTISE.</span>
            </MaskedLine>
          </h1>
          <FadeIn delay={0.4} className="mt-8 max-w-xl">
            <p className="font-manrope text-base sm:text-lg leading-relaxed text-bm-gray">
              Eleven disciplines, one obsessive standard. Pick one, or hand us
              the whole growth engine — we run it around the clock.
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="pb-24 lg:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {SERVICES.map((s, i) => (
            <FadeIn key={s.slug} delay={0.05}>
              <div
                data-testid={`service-row-${s.slug}`}
                className={`group grid grid-cols-1 md:grid-cols-12 gap-8 items-center border-t border-bm-line py-12 lg:py-16 ${
                  i === SERVICES.length - 1 ? "border-b" : ""
                }`}
              >
                <div className={`md:col-span-5 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                  <div className="relative h-64 sm:h-80 overflow-hidden rounded-xl border border-bm-line">
                    <img
                      src={s.image}
                      alt={s.title}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                    />
                    <span className="absolute top-4 left-4 rounded-full bg-white/90 backdrop-blur px-4 py-1.5 font-syne text-xs font-bold text-bm-navy">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                </div>
                <div className={`md:col-span-7 ${i % 2 === 1 ? "md:order-1 md:pr-8" : "md:pl-8"}`}>
                  <h2 className="font-syne text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-bm-ink transition-colors duration-300 group-hover:text-bm-blue">
                    {s.title}
                  </h2>
                  <p className="mt-5 max-w-xl font-manrope text-base leading-relaxed text-bm-gray">
                    {s.blurb}
                  </p>
                  <div className="mt-6 flex flex-wrap gap-2">
                    {s.tags.map((t) => (
                      <span
                        key={t}
                        className="rounded-full bg-bm-surface px-4 py-1.5 font-manrope text-xs font-semibold text-bm-ink"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                  <Link
                    to="/contact"
                    data-testid={`service-cta-${s.slug}`}
                    className="mt-8 inline-flex items-center gap-2 font-manrope text-sm font-bold text-bm-blue"
                  >
                    Enquire about {s.title}
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </Link>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </section>
    </main>
  );
}
